<template>
    <div class="signature-pad">

        <div class="canvas-container">
            <canvas ref="signatureCanvas" @mousedown="startDrawing" @mousemove="draw" @mouseup="stopDrawing"
                @mouseleave="stopDrawing" @touchstart="handleTouchStart" @touchmove="handleTouchMove"
                @touchend="stopDrawing"></canvas>
            <p v-if="isEmpty" class="placeholder">请在此处签名</p>
        </div>

        <div class="tools-panel">
            <div class="tool-group">
                <label>画笔颜色：</label>
                <div class="color-options">
                    <div v-for="color in colorOptions" :key="color" class="color-option"
                        :class="{ active: selectedColor === color }" :style="{ backgroundColor: color }"
                        @click="selectColor(color)"></div>
                </div>
            </div>

            <div class="tool-group">
                <label>画笔粗细：</label>
                <div class="width-options">
                    <div v-for="width in widthOptions" :key="width" class="width-option"
                        :class="{ active: selectedWidth === width }" @click="selectWidth(width)">
                        <span :style="{ height: width + 'px', width: width * 3 + 'px' }"></span>
                    </div>
                </div>
            </div>
        </div>

        <div class="action-buttons">
            <button class="btn btn-clear" @click="clearCanvas" :disabled="isEmpty">
                清空画布
            </button>
            <button class="btn btn-undo" @click="undo" :disabled="!canUndo">
                撤销上一步
            </button>
            <button class="btn btn-save" @click="saveSignature" :disabled="isEmpty">
                预览
            </button>
        </div>

        <div v-if="signatureDataUrl" class="preview-section">
            <h3>签名预览</h3>
            <img :src="signatureDataUrl" alt="签名预览" class="preview-image">
        </div>
    </div>
</template>

<script>
export default {
    name: 'SignaturePad',
    data() {
        return {
            canvas: null,
            ctx: null,
            isDrawing: false,
            lastX: 0,
            lastY: 0,
            selectedColor: '#000000',
            selectedWidth: 2,
            colorOptions: ['#000000', '#e74c3c', '#3498db', '#2ecc71', '#f39c12', '#9b59b6'],
            widthOptions: [1, 2, 3, 5, 8],
            paths: [],
            currentPath: [],
            signatureDataUrl: '',
            isEmpty: true
        }
    },
    computed: {
        canUndo() {
            return this.paths.length > 0
        }
    },
    mounted() {
        // this.initCanvas()
        // window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        // window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        initCanvas() {
            this.$nextTick(() => {
                console.log('进入initCanvas')
                this.canvas = this.$refs.signatureCanvas
                this.ctx = this.canvas.getContext('2d')

                this.resizeCanvas()
                this.setupCanvasStyle()
            });
            
        },

        resizeCanvas() {
            const container = this.canvas.parentElement
            console.log(container)
            const dpr = window.devicePixelRatio || 1

            // 设置canvas显示尺寸
            this.canvas.style.width = container.clientWidth + 'px'
            this.canvas.style.height = '300px'

            // 设置canvas实际像素尺寸（考虑设备像素比）
            this.canvas.width = container.clientWidth * dpr
            this.canvas.height = 300 * dpr

            // 缩放画布以匹配像素比
            this.ctx.scale(dpr, dpr)
        },

        handleResize() {
            // 保存当前绘制内容
            const currentDataUrl = this.canvas.toDataURL()

            // 调整画布大小
            this.resizeCanvas()
            this.setupCanvasStyle()

            // 如果有内容，重新绘制
            if (!this.isEmpty) {
                const img = new Image()
                img.onload = () => {
                    this.ctx.drawImage(img, 0, 0, this.canvas.width, this.canvas.height)
                }
                img.src = currentDataUrl
            }
        },

        setupCanvasStyle() {
            this.ctx.lineJoin = 'round'
            this.ctx.lineCap = 'round'
            this.ctx.lineWidth = this.selectedWidth
            this.ctx.strokeStyle = this.selectedColor
        },

        startDrawing(e) {
            console.log('进入startDrawing')
            this.isDrawing = true
            const point = this.getCoordinates(e)
            this.lastX = point.x
            this.lastY = point.y

            // 开始新的路径
            this.currentPath = [{
                x: this.lastX,
                y: this.lastY,
                color: this.selectedColor,
                width: this.selectedWidth
            }]

            this.isEmpty = false
        },

        draw(e) {
            if (!this.isDrawing) return

            e.preventDefault()
            const point = this.getCoordinates(e)

            // 绘制线条
            this.ctx.beginPath()
            this.ctx.moveTo(this.lastX, this.lastY)
            this.ctx.lineTo(point.x, point.y)
            this.ctx.stroke()

            // 更新最后坐标
            this.lastX = point.x
            this.lastY = point.y

            // 记录当前路径点
            this.currentPath.push({
                x: point.x,
                y: point.y,
                color: this.selectedColor,
                width: this.selectedWidth
            })
        },

        stopDrawing() {
            if (this.isDrawing) {
                this.isDrawing = false

                // 保存当前路径
                if (this.currentPath.length > 0) {
                    this.paths.push([...this.currentPath])
                    this.currentPath = []
                }
            }
        },

        handleTouchStart(e) {
            e.preventDefault()
            this.startDrawing(e.touches[0])
        },

        handleTouchMove(e) {
            e.preventDefault()
            this.draw(e.touches[0])
        },

        getCoordinates(e) {
            const rect = this.canvas.getBoundingClientRect()
            const scaleX = this.canvas.width / (window.devicePixelRatio * rect.width)
            const scaleY = this.canvas.height / (window.devicePixelRatio * rect.height)

            return {
                x: (e.clientX - rect.left) * scaleX,
                y: (e.clientY - rect.top) * scaleY
            }
        },

        selectColor(color) {
            this.selectedColor = color
            this.ctx.strokeStyle = color
        },

        selectWidth(width) {
            this.selectedWidth = width
            this.ctx.lineWidth = width
        },

        clearCanvas() {
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
            this.paths = []
            this.currentPath = []
            this.signatureDataUrl = ''
            this.isEmpty = true
        },

        undo() {
            if (this.paths.length > 0) {
                // 移除最后一个路径
                this.paths.pop()

                // 清空画布
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

                // 重绘所有路径
                this.redrawPaths()

                // 如果没有路径了，设置为空状态
                if (this.paths.length === 0) {
                    this.isEmpty = true
                }
            }
        },

        redrawPaths() {
            this.paths.forEach(path => {
                if (path.length > 0) {
                    this.ctx.beginPath()
                    this.ctx.moveTo(path[0].x, path[0].y)
                    this.ctx.strokeStyle = path[0].color
                    this.ctx.lineWidth = path[0].width

                    for (let i = 1; i < path.length; i++) {
                        this.ctx.lineTo(path[i].x, path[i].y)
                    }

                    this.ctx.stroke()
                }
            })
        },

        saveSignature() {

            this.signatureDataUrl = this.canvas.toDataURL('image/png')
            console.log(this.signatureDataUrl)
            return false
            // 创建临时canvas用于导出
            const tempCanvas = document.createElement('canvas')
            const tempCtx = tempCanvas.getContext('2d')
            const dpr = window.devicePixelRatio || 1

            tempCanvas.width = this.canvas.width
            tempCanvas.height = this.canvas.height

            // 设置白色背景
            tempCtx.fillStyle = 'white'
            tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height)

            // 绘制签名
            tempCtx.drawImage(this.canvas, 0, 0)

            // 生成数据URL
            this.signatureDataUrl = tempCanvas.toDataURL('image/png')
            console.log(this.signatureDataUrl)
            
            // 触发保存事件
            // this.$emit('save', this.signatureDataUrl)

            // 创建下载链接
            // const link = document.createElement('a')
            // link.download = `signature_${new Date().getTime()}.png`
            // link.href = this.signatureDataUrl
            // document.body.appendChild(link)
            // link.click()
            // document.body.removeChild(link)
        },
    }
}
</script>

<style scoped>
.signature-pad {
    max-width: 800px;
    margin: 0 auto;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 25px;
    font-family: 'Arial', sans-serif;
}

.title {
    text-align: center;
    margin-bottom: 20px;
    color: #2c3e50;
}

.canvas-container {
    border: 2px dashed #ddd;
    border-radius: 8px;
    margin-bottom: 20px;
    background-color: #fafafa;
    position: relative;
    overflow: hidden;
}

canvas {
    display: block;
    cursor: crosshair;
    width: 100%;
    height: 300px;
    touch-action: none;
}

.placeholder {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #aaa;
    font-size: 18px;
    pointer-events: none;
}

.tools-panel {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
}

.tool-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.tool-group label {
    font-weight: bold;
    color: #555;
    white-space: nowrap;
}

.color-options,
.width-options {
    display: flex;
    gap: 8px;
}

.color-option {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid transparent;
    transition: transform 0.2s;
}

.color-option.active {
    border-color: #333;
    transform: scale(1.1);
}

.width-option {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #eee;
    cursor: pointer;
    transition: all 0.2s;
}

.width-option.active {
    background-color: #3498db;
    color: white;
}

.width-option span {
    display: block;
    background-color: currentColor;
    border-radius: 2px;
}

.action-buttons {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-bottom: 20px;
}

.btn {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
    transition: all 0.3s;
    flex: 1;
    min-width: 120px;
}

.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-clear {
    background-color: #e74c3c;
    color: white;
}

.btn-clear:not(:disabled):hover {
    background-color: #c0392b;
}

.btn-undo {
    background-color: #f39c12;
    color: white;
}

.btn-undo:not(:disabled):hover {
    background-color: #d35400;
}

.btn-save {
    background-color: #2ecc71;
    color: white;
}

.btn-save:not(:disabled):hover {
    background-color: #27ae60;
}

.preview-section {
    margin-top: 30px;
    text-align: center;
    padding-top: 20px;
    border-top: 1px solid #eee;
}

.preview-section h3 {
    margin-bottom: 15px;
    color: #2c3e50;
}

.preview-image {
    max-width: 100%;
    max-height: 200px;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-top: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

@media (max-width: 600px) {
    .signature-pad {
        padding: 15px;
    }

    .tools-panel {
        flex-direction: column;
        gap: 15px;
    }

    .tool-group {
        flex-direction: column;
        align-items: flex-start;
    }

    .action-buttons {
        flex-direction: column;
    }

    .btn {
        min-width: auto;
    }
}
</style>